import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "multi-level-compoent" }
const _hoisted_2 = { class: "li-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_level_item = _resolveComponent("level-item")!
  const _component_multi_level = _resolveComponent("multi-level", true)!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.thisList, (item, index) => {
      return (_openBlock(), _createElementBlock(_Fragment, {
        key: item.id
      }, [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createBlock(_component_level_item, {
            data: item,
            showOperation: _ctx.showOperation,
            onDeleteFirst: _ctx.deleteFirst,
            key: item.id
          }, null, 8, ["data", "showOperation", "onDeleteFirst"]))
        ]),
        (item.children && item.children.length > 0)
          ? _withDirectives((_openBlock(), _createBlock(_component_multi_level, {
              showOperation: _ctx.showOperation,
              list: item.children,
              key: item.id
            }, null, 8, ["showOperation", "list"])), [
              [_vShow, item.active]
            ])
          : _createCommentVNode("", true)
      ], 64))
    }), 128))
  ]))
}